/**
 * 获取用户
 */
export const thirdPayLogin = '/uout/auth/thirdPay/login';
/**
 * 币种和档位映射关系
 */
export const getCurrencyGear = '/center/thirdPay/currency/gear';
/**
 * 支付方式列表获取
 */
export const getAllPayMode = '/center/thirdPay/pay/mode';
/**
 * 三方支付商品列表获取
 */
export const serverIapList = '/center/thirdPay/server/iap/list';
/**
 * 三方支付消费记录
 */
export const getThirdPayOrderList = '/center/thirdPay/purchaseList/get';
/**
 * 创建三方支付订单
 */
export const createThirdPayOrder = '/pout/thirdPay/order/create';
/**
 * 三方订单校验
 */
export const verifyThirdPayOrder = '/pout/thirdPay/order/verify';
/**
 * 执行请款
 */
export const thirdPayOrderRequestPay = '/pout/thirdPay/order/requestPay';
/**
 * 获取游戏角色上一次支付成功的支付方式
 */
export const getDefaultPayment = '/center/thirdPay/role/default/payment';
/**
 * 基于 token 列表检验合法角色 token
 */
export const checkRolesToken = '/center/thirdPay/check/roles/token';
/**
 * 三方支付查询子订单
 */
export const orderSublist = '/center/thirdPay/purchase/order/sublist';
/**
 * 三方商城获取用户 礼金 剩余数
 */
export const getUserPointData = '/pout/thirdPay/point/get/user/remaining/point/count';
/**
 * 三方商城获取 礼金 使用规则说明
 */
export const getUserPointRule = '/pout/thirdPay/point/get/activity/rule/usage/statement';
/**
 * 三方商城获取 礼金 使用规则开关
 */
export const getUserPointSwitch = '/pout/thirdPay/point/get/activity/rule/usage/switch';
/**
 * 三方商城获取邮箱验证码
 */
export const getEmailCode = '/pout/thirdPay/auth/info/send/verify/email/code';
/**
 * 三方商城设置三方支付安全邮箱
 */
export const setPayEmail = '/pout/thirdPay/auth/info/set/user/pay/email';
/**
 * 三方商城校验用户是否为首次支付
 */
export const getPointInit = '/pout/thirdPay/auth/info/check/initial/point/pay';
/**
 * 三方商城校验用户是否已经设置支付密码
 */
export const getPayPwdFlag = '/pout/thirdPay/auth/info/check/pay/password/configured';
/**
 * 三方商城校验用户是否设置安全邮箱
 */
export const getEmailFlag = '/pout/thirdPay/auth/info/check/pay/email/configured';
/**
 * 三方商城设置三方支付支付密码
 */
export const setPayPwd = '/pout/thirdPay/auth/info/set/user/pay/password';
/**
 * 三方商城修改三方支付支付密码
 */
export const changePayPwd = '/pout/thirdPay/auth/info/modify/user/pay/password';
/**
 * 查询三方支付安全邮箱地址
 */
export const getUserPayEmail = '/pout/thirdPay/auth/info/get/user/pay/email';
/**
 * 三方商城修改密码时校验支付旧密码
 */
export const checkPayPwd = '/pout/thirdPay/auth/info/check/pay/user/old/password';
/**
 * 三方商城修改密码时校验验证码
 */
export const checkPayEmail = '/pout/thirdPay/auth/info/check/pay/user/email/code';
/**
 * 版本号查询
 */
export const getVersion = '/pout/thirdPay/version';
/**
 * PC 海外商城获取玩家登录信息
 */
export const getPCInfo = '/uout/auth/third/pay/pc/get/info';
/**
 * PC 版商城根据网络环境查询解析国家信息
 */
export const getPCCountry = '/pc/third/pay/get/network/country';
/**
 * PC 版商城查询国家列表
 */
export const getPCAllCountry = '/pc/third/pay/get/available/pay/country';
/**
 * PC 版支付金额/国家等查询可用支付方式
 */
export const getPCPayM = '/office/web/mall/pay/mode';
/**
 * PC 版币种和档位映射关系
 */
export const getPCGear = '/pc/third/pay/currency/gear';
/**
 * PC 查询所有币种和符号的映射关系
 */
export const getAllGear = '/pc/third/pay/get/unity/all/currency';

/**
 * Web 官网商城查询地区列表
 */
export const getWebRegion = '/office/web/mall/pay/region';
/**
 * Web 官网查询应用基础数据
 */
export const getWebAppInfo = '/office/web/common/get/app/info';
/**
 * Web 官网商城查询用户所在地区支付方式
 */
export const getWebPayMode = '/office/web/mall/pay/mode';
/**
 * Web 官网商城查询未登录商品列表
 */
export const getWebUnLoadGoods = '/office/web/mall/goods/list';
/**
 * Web 官网查询应用开关
 */
export const getWebSwitch = '/office/web/common/get/switchInfo';
/**
 * Web 官网登录 - NT 登录
 */
export const getNtLogin = '/office/web/auth/nt/login';
/**
 * Web 官网扫码登录查询鉴权数据
 */
export const getScanLogin = '/office/web/auth/get/scan/login/info';
/**
 * PC 扫码登陆生成唯一码
 */
export const getGeneCode = '/center/common/pc/gene/code';
/**
 * PC 监听获取账号扫码登陆状态
 */
export const getGeneInfo = '/office/web/auth/get/scan/login/info';
/**
 * Web 官网商城查询平台账号下的所有角色信息
 */
export const getWebRoleList = '/office/web/user/get/role/list';
/**
 * Web 官网获取商城角色鉴权身份数据
 */
export const getMallLoginStatus = '/office/web/auth/mall/login';
/**
 * Web 官网退出账号登陆
 */
export const getWebLogout = '/office/web/auth/logout';
/**
 * Web code码登陆
 */
export const getCodeLogin = '/office/web/auth/third/code/login/' + CONFIG.appId;
/**
 * Web vk渠道获取重定向参数
 */
export const getVKParams = '/office/web/auth/get/third/vk_id/authorize/values/' + CONFIG.appId;
/**
 * Web vk渠道码登陆
 */
export const getVKCodeLogin = '/office/web/auth/get/third/vk_id/login/info/' + CONFIG.appId;